import React, { FC, memo } from 'react'
import { InlineForm } from '@ucheba/ui/components/InlineForm/desktop'
import { TextField } from '@ucheba/ui/components/TextField/desktop'
import { Form } from '@ucheba/ui/components/Form/desktop'
import { Field, Formik } from 'formik'
import { ESpecialitiesDataKeys } from '@ucheba/store/specialities/search/types'
import { useSpecialitiesPageSearchFormCore } from '../bll'
import data from '../data.json'

const SpecialitiesPageSearchForm: FC = () => {
  const { onSubmit, initialValues } = useSpecialitiesPageSearchFormCore()
  const { searchForm } = data

  const field = (
    <Field
      as={TextField}
      type='text'
      name={ESpecialitiesDataKeys.query}
      label={searchForm.label}
    />
  )

  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit} enableReinitialize>
      <Form fillByQuery>
        <InlineForm buttonText={searchForm.buttonText} control={field} />
      </Form>
    </Formik>
  )
}

export default memo(SpecialitiesPageSearchForm)
